// Mirror cổng của internal/core/halfdayslot. FE chỉ ẩn hiện; phạm vi cơ sở xét ở máy chủ.
import type { Staff } from "@/lib/authv2/store";
import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";

type PermUser = Pick<Staff, "id" | "role"> | null | undefined;

export function canReadHalfDaySlots(user: PermUser): boolean {
  return !!user && hasPermission(ACTION.HalfDaySlotRead);
}

/** Mở, đóng suất và đổi thợ: người xếp lịch cơ sở. */
export function canWriteHalfDaySlots(user: PermUser): boolean {
  return !!user && hasPermission(ACTION.HalfDaySlotWrite);
}

/** Kết quả có doanh thu: người trông cơ sở và kế toán, không mở cho quầy. */
export function canReadHalfDayReport(user: PermUser): boolean {
  return !!user && hasPermission(ACTION.HalfDaySlotReport);
}

/** Phòng được chốt concept / đổi suất trên đơn dù không có quyền ghi đơn. */
const ORDER_SLOT_DEPTS = new Set(["reception", "marketing"]);

/**
 * Chốt concept và đổi suất của một đơn. Gương cổng máy chủ
 * `auth.AllowOrDept("order.write", "reception", "marketing")` ở
 * `order/ekip_members_handler.go` — người không qua cổng thì nút khoá sẵn.
 */
export function canEditHalfDayOrder(user: (PermUser & { department?: string | null }) | null | undefined): boolean {
  if (!user) return false;
  if (hasPermission(ACTION.OrderWrite)) return true;
  return ORDER_SLOT_DEPTS.has((user.department || "").trim().toLowerCase());
}

/** Lời trên nút khi bị khoá — nói lý do thay vì để bấm rồi ăn 403. */
export const HALF_DAY_ORDER_LOCKED_REASON = "Chỉ người có quyền sửa đơn, lễ tân hoặc marketing đổi được";
